// Texts of the report analysis workflow. Error codes are the ones lud-backend returns
// (services/reportIngestionService.js, utils/reportValidation, utils/reportParsing, routes/reportRoutes.js).

export const TEXT = {
  ar: {
    title: "تحليل التقارير",
    subtitle: "ارفع ملفات التطبيقات الأصلية؛ يتحقق النظام منها ويحللها ويحفظ التقارير والملفات معاً.",
    guideVideo: {
      W: (app) => `طريقة تحميل التقرير اليومي من ${app}`,
      M: (app) => `طريقة تحميل التقرير الشهري من ${app}`,
    },
    flow: {
      ackCheck: "راجعت هذه التحذيرات وأؤكد أن الملفات تعود للمتجر المختار.",
      ackPeriodCheck: (period) => `أدرك أن صفوف الأشهر الأخرى تُسند إلى التقرير الشهري لـ ${period} مع بقاء تواريخها الأصلية.`,
      ackDailyCheck: (period, rows) => `أدرك أن ${rows} صفاً من خارج ${period} تُستبعد ولا تُحفظ.`,
      ackBranchesCheck: (rows, store) => `أدرك أن ${rows} صفاً لفروع مسجّلة لمتجر آخر لن تُحفظ ضمن ${store}، ولن تُغيَّر سجلات أي متجر آخر.`,
      ackCheckMismatch: "راجعت تفاصيل الفروع وهذه التحذيرات وأريد المتابعة إلى المعاينة.",
      stepper: "خطوات تحليل التقارير",
      stepLabels: { setup: "المتجر والفترة", files: "التطبيقات والملفات", validate: "الفحص", preview: "المعاينة", result: "الحفظ والنتيجة" },
      next: "التالي",
      nextCheck: "التالي: فحص الملفات",
      backToSetup: "العودة إلى المتجر والفترة",
      backToFiles: "العودة إلى الملفات",
      backToChecks: "العودة إلى الفحص",
      backToPreview: "العودة إلى المعاينة",
      continuePreview: "المتابعة إلى المعاينة",
      acknowledgeContinue: "تأكيد التحذيرات والمتابعة إلى المعاينة",
      confirmSave: "تأكيد وحفظ",
      startNew: "بدء تحليل جديد",
      retrySave: "إعادة محاولة الحفظ",
      retryCheck: "إعادة الفحص",
      retryPreview: "إعادة تجهيز المعاينة",
      setupTitle: "المتجر والفترة",
      setupHint: "اختر المتجر وشهر التقرير ونوع التحليل. التطبيقات والملفات في الخطوة التالية.",
      filesTitle: "التطبيقات والملفات",
      filesHint: "اختر التطبيقات وارفع ملفاتها في القسم الصحيح. يتم فحص الملفات في الخطوة التالية.",
      chooseApps: "اختر تطبيقاً واحداً على الأقل للمتابعة.",
      filesCount: (n, shown = n) => `${shown} ملف`,
      noFilesYet: "لا توجد ملفات بعد",
      checksTitle: "فحص الملفات",
      checksHint: "الفحص والمعاينة لا يحفظان أي شيء.",
      precheckNotice: "لم يُرسل أي شيء إلى الخادم. صحّح المشكلات التالية في خطوة الملفات ثم أعد الفحص.",
      summary: { appsChecked: "التطبيقات المفحوصة", filesChecked: "الملفات المفحوصة", rowsChecked: "صفوف المصدر المفحوصة", appsReady: "تطبيقات جاهزة", appsWarnings: "تطبيقات بتحذيرات", appsErrors: "تطبيقات بأخطاء مانعة" },
      overall: { ready: "جاهز", readyWithWarnings: "جاهز مع تحذيرات", requiresCorrection: "يتطلب تصحيحاً" },
      blockingTitle: "لا يمكن المتابعة قبل تصحيح الأخطاء",
      blockingHint: (n, shown = n) => `${shown} خطأ مانع. صحّح ما يلي ثم أعد الفحص:`,
      noIssues: "لا توجد تحذيرات أو أخطاء لهذا التطبيق.",
      filesChecked: "الملفات المفحوصة",
      ackTitle: "تأكيد التحذيرات",
      ackHint: "يجب تأكيد التحذيرات صراحةً قبل المعاينة. لا يُحفظ شيء الآن.",
      allClear: "لا توجد تحذيرات: جميع الملفات تطابق المتجر والفترة ونوع التقرير.",
      checking: "جارٍ فحص الملفات على الخادم…",
      previewing: "جارٍ تجهيز معاينة التحليل…",
      previewTitle: "معاينة التحليل",
      previewHint: "هذا ما سيُحفظ عند التأكيد. القيم محسوبة على الخادم من الملفات الأصلية.",
      overview: "الملخص العام",
      appsAnalyzed: "التطبيقات المحللة",
      filesAnalyzed: "الملفات المحللة",
      appSummaries: "ملخص كل تطبيق",
      staleRetained: "سجلات قديمة محتفظ بها",
      staleExplain: "السجلات القديمة التي لم تعد في التحليل الجديد تبقى محفوظة ولا تُحذف تلقائياً.",
      dbLine: (insert, update, unchanged) => `${insert} جديد · ${update} محدّث · ${unchanged} دون تغيير`,
      databaseChanges: "تغييرات قاعدة البيانات",
      warningsSummary: (n) => `التحذيرات المؤكدة (${n})`,
      savingTitle: "جارٍ الحفظ",
      savingRunning: "طلب الحفظ قيد التنفيذ. لا تغلق الصفحة حتى تظهر النتيجة.",
      savingApps: "التطبيقات قيد المعالجة",
      uploadProgress: "رفع الملفات",
      serverWorking: "اكتمل الرفع؛ الخادم يحلل ويحفظ في عملية واحدة…",
      successTitle: "تم حفظ التحليل",
      successHint: "أُزيلت الملفات المؤقتة وبيانات الفحص والمعاينة من الصفحة. يبقى هذا الملخص ظاهراً.",
      appsSaved: "التطبيقات المحفوظة",
      filesSaved: "الملفات المحفوظة",
      inserted: "سجلات مضافة",
      updated: "سجلات محدّثة",
      unchanged: "سجلات دون تغيير",
      warningsAcknowledged: "تحذيرات مؤكدة",
      failureTitle: "لم يكتمل الحفظ",
      failureStage: "المرحلة",
      reason: "السبب",
      application: "التطبيق",
      section: "القسم",
      affectedFiles: "الملفات المتأثرة",
      suggestedAction: "الإجراء المقترح",
      savedFalse: "أكد الخادم أنه لم يُحفظ أي شيء.",
      savedUnknown: "لم يتمكن الخادم من تأكيد ما إذا حُفظ شيء. راجع التقارير قبل إعادة المحاولة؛ إعادة إرسال نفس الملفات لا تحفظها مرتين.",
      filesKept: "الملفات المرفوعة ما زالت في الصفحة للتصحيح وإعادة المحاولة.",
      requestFailed: "تعذّر إكمال الطلب",
      checksNeverSave: "الفحص والمعاينة لا يحفظان أي شيء.",
    },
    details: {
      worksheet: "ورقة العمل",
      section: "القسم",
      missingColumns: "الأعمدة المطلوبة غير الموجودة",
      expectedColumns: "الأعمدة المتوقعة",
      actualColumns: "الأعمدة الموجودة في الملف",
      moreColumns: (n) => `و${n} أعمدة أخرى`,
      suggestion: (expected, actual) => `العمود المتوقع "${expected}" — يوجد في الملف "${actual}". صدّر التقرير الأصلي أو أعد تسمية العمود إلى "${expected}".`,
      selectedStore: "المتجر المختار",
      mismatchedBranches: "الفروع غير المطابقة",
      matchedBranches: "الفروع المطابقة",
      noMatchedBranches: "لا يوجد فرع مطابق للمتجر المختار في هذا الملف.",
      application: "التطبيق",
      totalAffectedRows: "إجمالي الصفوف المتأثرة",
      showBranches: (n, shown = n) => `عرض ${shown} فرع`,
      crossStoreNote: (rows, store) => `قد تعود هذه الفروع لمتجر آخر. راجع تفاصيل الفروع قبل المتابعة. لن تُحفظ صفوفها (${rows}) ضمن ${store} ولن تُسند إلى أي فرع آخر، ولن تُغيَّر سجلات المتجر الآخر.`,
      branchId: "رقم الفرع",
      matchedAs: (name) => `يطابق: ${name}`,
      rows: (n, shown = n) => `${shown} صف`,
      affectedRows: "عدد الصفوف المتأثرة",
      affectedFile: "الملف المتأثر",
      selectedPeriod: "الفترة المختارة",
      detectedPeriods: "الفترات الموجودة في الملف",
      statementPeriods: "أشهر التقرير الشهري",
      included: "مُدرج",
      excluded: "مستبعد",
      totalSourceRows: "إجمالي صفوف المصدر",
      includedRows: "الصفوف المُدرجة",
      excludedRows: "الصفوف المستبعدة",
      assignedRows: (period) => `الصفوف المسندة إلى ${period}`,
      dailyNote: (included, excluded, period) => `تُحلَّل وتُحفظ ${included} صفاً فقط من ${period}. تُستبعد الصفوف الأخرى (${excluded}).`,
      monthlyNote: (rows, period) => `تُسهم جميع الصفوف المطبّقة (${rows}) في التقرير الشهري لـ ${period}. تبقى تواريخ المصدر الأصلية دون تغيير.`,
      branchExcluded: "مستبعد",
      branchAssigned: (names) => `يُسند إلى: ${names}`,
      branchSharedName: "الاسم مستخدم لدى متجر آخر",
      candidates: (names) => `فروع محتملة: ${names}`,
      unmatchedRows: (rows, more, branch, reason, total) => {
        const where = `${total === 1 ? "الصف" : "الصفوف"} ${rows}${more > 0 ? ` و${more} صفوف أخرى` : ""}`;
        if (reason === "no_branch") return `${where}: لا يوجد اسم أو رقم فرع.`;
        if (reason === "ambiguous") return `${where}: الفرع '${branch}' يطابق أكثر من فرع مسجل ضمن المتجر المختار، ولم يُحدَّد أي منها تلقائياً.`;
        if (reason === "no_provider_id") return `${where}: الفرع '${branch}' مسجل ضمن المتجر المختار، لكن لا يوجد له رقم فرع في هذا التطبيق، فلا يمكن حفظ صفوفه.`;
        return `${where}: الفرع '${branch}' لا يطابق أي فرع مسجل ضمن المتجر المختار.`;
      },
      relatedFile: "الملف المرتبط",
      duplicateNote: "الصفوف نفسها في جزأين من التقرير تُحتسب مرتين؛ احذف الجزء المكرر.",
      samples: "أمثلة",
      action: "الإجراء",
      unknownStore: "—",
    },
    store: "المتجر",
    storePlaceholder: "اختر المتجر",
    period: "شهر التقرير",
    mode: "نوع التحليل",
    modes: { W: "يومي", M: "شهري" },
    apps: "التطبيقات",
    appsHint: "اختر تطبيقاً واحداً أو أكثر.",
    loadingParts: "جارٍ تحميل الملفات الحالية…",
    existing: "ملفات محفوظة",
    keep: "سيُرسل كما هو",
    willReplace: (version) => `سيُستبدل — الإصدار ${version}`,
    version: (n) => `الإصدار ${n}`,
    replace: "استبدال",
    download: "تنزيل",
    addFiles: "إضافة ملفات",
    addFile: "إضافة ملف",
    newPart: "جزء جديد",
    remove: "إزالة",
    noFiles: "لم يُرفع ملف",
    optional: "اختياري",
    ready: "جاهز",
    notReady: "غير جاهز",
    includeAll: "يقرأ التحليل جميع ملفات هذا التطبيق لهذا الشهر معاً، لذلك تُرسل الملفات المحفوظة أيضاً. الملفات التي لم تستبدلها تُرسل كما هي دون إنشاء إصدار جديد.",
    preview: "معاينة التحليل",
    cancel: "إلغاء",
    phases: { preparing: "تجهيز الملفات", uploading: "رفع الملفات", validating: "التحقق", previewing: "تجهيز المعاينة", committing: "حفظ التقارير" },
    processing: "يعالج الخادم الملفات…",
    protections: { disputed: "نزاع", objected: "اعتراض", readiness_exception: "استثناء جاهزية" },
    backToFiles: "العودة إلى الملفات",
    notAvailable: "غير متوفر",
    preview2: {
      sourceRows: "صفوف المصدر",
      branches: "الفروع",
      branch: "الفرع",
      byBranch: "حسب الفرع",
      savedTo: "تُحفظ السجلات ضمن",
      rowsLine: (source, included, excluded) => `صفوف المصدر: ${source} · مُدرجة: ${included} · مستبعدة: ${excluded}`,
      rowsAssignedLine: (source, assigned, excluded, period) => `صفوف المصدر: ${source} · مسندة إلى ${period}: ${assigned} · مستبعدة: ${excluded}`,
      rowsIncluded: "صفوف مُدرجة",
      rowsExcluded: "صفوف مستبعدة",
      noBranches: "لا يوجد فرع مطابق؛ لن تُحفظ سجلات لهذا التطبيق",
      excludedRows: (rows, branches) => `مستبعد: ${rows} صفاً من ${branches} فرع مسجّل لمتجر آخر — لا تُحفظ ولا تُسند إلى أي فرع.`,
      compensationRows: "سجلات التعويض",
      compensationTotal: "إجمالي التعويضات التفصيلية",
      changesTitle: (n, shown = n) => `الفرق عن القيم المحفوظة (${shown} سجل سيُحدّث)`,
      field: "البند",
      saved: "المحفوظ حالياً",
      analyzed: "بعد التحليل",
      difference: "الفرق",
    },
    metrics: {
      orders: "الطلبات المكتملة", sales: "المبيعات", commission: "العمولة", paymentFees: "رسوم الدفع", deliveryOffer: "عروض التوصيل",
      offers: "العروض", vat: "ضريبة القيمة المضافة", compensation: "التعويضات", rejected: "الطلبات المرفوضة", canceled: "الطلبات الملغاة", net: "الصافي",
    },
    review: {
      problem: "مشكلة",
      details: "التفاصيل",
      phases: { preparing: "تجهيز الملفات", uploading: "الرفع", validating: "فحص الملفات", previewing: "معاينة التحليل", committing: "الحفظ" },
      filesCount: (n, shown = n) => `${shown} ملف`,
      rows: (n, shown = n) => `${shown} صف`,
      warningsCount: (n, shown = n) => `${shown} تحذير`,
      errorsCount: (n, shown = n) => `${shown} خطأ`,
      errorsHeading: "الأخطاء",
      warningsHeading: "التحذيرات",
      row: "صف",
      action: "الإجراء",
      acknowledgedTag: "مؤكَّد",
      database: { insert: "سجل جديد", update: "سجل محدّث", unchanged: "سجل دون تغيير", stale: "محتفظ به للمراجعة", conflict: "تعارض مع سجلات محمية", added: "ملف مضاف", replaced: "ملف مستبدل" },
      actions: {
        MISSING_REQUIRED_COLUMNS: "ارفع الملف الصحيح لهذا التقرير كما صدّره التطبيق.",
        SHEET_NOT_FOUND: "ارفع الملف الكامل الذي يحتوي على جميع أوراق العمل.",
        WRONG_PROVIDER: "ارفع هذا الملف ضمن التطبيق الذي يعود إليه.",
        WRONG_REPORT_KIND: "ارفع الملف في قسم التقرير المطابق.",
        SECTION_NOT_IN_MODE: "اختر نوع التحليل الذي يستخدم هذا التقرير أو احذف الملف.",
        UNKNOWN_REPORT_SECTION: "احذف الملف وأضفه مرة أخرى في القسم الصحيح.",
        BRANCH_BELONGS_TO_ANOTHER_STORE: "تحقق من المتجر المختار أو ارفع ملف هذا المتجر.",
        CROSS_STORE_BRANCH_MISMATCH: "راجع تفاصيل الفروع قبل المتابعة، أو اختر المتجر الذي يعود إليه الملف.",
        CROSS_FILE_CONFLICT: "تأكد أن جميع الملفات من نفس التصدير لنفس المتجر.",
        PERIOD_MISMATCH: "ارفع تقرير الشهر المختار، أو اختر الشهر الذي يعود إليه التقرير.",
        NO_ROWS_IN_PERIOD: "ارفع تقرير الشهر المختار، أو اختر الشهر الذي يعود إليه التقرير.",
        SOURCE_PERIOD_INCONSISTENT: "ارفع ملفات الطلبات والرسوم لنفس شهر التقرير الشهري.",
        ROWS_OUTSIDE_SELECTED_PERIOD: "تأكد من الفترة المختارة؛ صفوف الأشهر الأخرى لا تُحفظ.",
        DUPLICATE_ROWS_ACROSS_PARTS: "احذف الجزء المكرر ثم أعد الفحص.",
        APP_NOT_CONFIGURED: "أضف حساب التطبيق للمتجر في إعدادات المتجر ثم أعد الفحص.",
        INVALID_DATE: "صحّح التواريخ غير الصالحة في الملف ثم ارفعه مرة أخرى.",
        INVALID_WORKBOOK: "صدّر الملف مرة أخرى من التطبيق ثم ارفعه.",
        UNSUPPORTED_FILE_TYPE: "احذف الملف من البطاقة وارفع ملفاً بصيغة xlsx أو xls أو csv.",
        MISSING_PART: "عد إلى الملفات: تُرسل جميع الأجزاء المحفوظة لهذا الشهر مرة أخرى.",
        LEGACY_PART: "افتح صفحة الملفات المحفوظة ورحّل الملف القديم أو احذفه، ثم أعد التحقق.",
        NO_FILES: "أضف ملفات التقرير في البطاقة أو ألغِ اختيار التطبيق.",
        HEADER_NOT_FOUND: "تأكد أن الملف هو تقرير هذا التطبيق لهذا القسم كما صُدّر دون تعديل، ثم ارفعه مرة أخرى.",
        INVALID_FILE_STRUCTURE: "تأكد أن الملف هو تقرير هذا التطبيق لهذا القسم كما صُدّر دون تعديل، ثم ارفعه مرة أخرى.",
        INVALID_CSV: "صدّر الملف مرة أخرى من التطبيق ثم ارفعه.",
        ROW_LIMIT_EXCEEDED: "قسّم الملف إلى ملفات أصغر.",
        UNSUPPORTED_ENCODING: "صدّر الملف مرة أخرى بصيغة xlsx أو CSV بترميز UTF-8.",
        PARSER_FAILED: "صدّر الملف مرة أخرى من التطبيق ثم ارفعه.",
        PARSER_UNAVAILABLE: "حاول مرة أخرى بعد بضع دقائق.",
        FILE_TOO_LARGE: "احذف الملف من البطاقة وارفع ملفاً أصغر.",
        EMPTY_FILE: "احذف الملف من البطاقة وارفع الملف مرة أخرى.",
        TOO_MANY_FILES: "احذف بعض الملفات أو حلّل التطبيقات كلاً على حدة.",
        PROTECTED_ROW_CONFLICT: "أنهِ النزاع أو الاعتراض أو راجعه أولاً، ثم أعد التحليل.",
        COMMIT_OUTCOME_UNKNOWN: "راجع صفحة التقارير لهذا الشهر؛ ثم أعد المحاولة بنفس الملفات إن لم يُحفظ التحليل.",
        BRANCH_NOT_MATCHED: "راجع الفروع الموجودة في الملف قبل المتابعة.",
        AMBIGUOUS_STORED_ROWS: "تواصل مع الدعم الفني لمراجعة السجلات المحفوظة.",
        ANALYZER_FAILED: (app) => `ارفع ملف تقرير ${app} صالحاً.`,
        fallback: "صحّح الملف ثم افحصه مرة أخرى.",
      },
    },
    validationStatus: { verified: "موثّق", partial: "موثّق جزئياً", unverified: "غير قابل للتحقق", rejected: "مرفوض" },
    issues: {
      PERIOD_MISMATCH: "توجد صفوف بتواريخ خارج الشهر والسنة المختارة.",
      NO_ROWS_IN_PERIOD: "خطأ — لا يوجد في الملف أي صف من الشهر والسنة المختارة؛ لا يوجد ما يُحلَّل أو يُحفظ.",
      ROWS_OUTSIDE_SELECTED_PERIOD: "تحذير — صفوف خارج فترة التقرير المختارة",
      DUPLICATE_ROWS_ACROSS_PARTS: "خطأ — صفوف هذا الملف موجودة أيضاً في جزء آخر من التقرير.",
      APP_NOT_CONFIGURED: "لا يوجد حساب لهذا التطبيق في المتجر؛ لا يمكن حفظ صفوف الملف.",
      INVALID_DATE: "بعض التواريخ غير صالحة.",
      BRANCH_BELONGS_TO_ANOTHER_STORE: "خطأ — الملف يحتوي على فرع مسجّل لمتجر آخر.",
      CROSS_STORE_BRANCH_MISMATCH: "تحذير — فروع لا تطابق المتجر المختار",
      LOOKS_LIKE_OTHER_SECTION: "أعمدة الملف تطابق قسماً آخر من تقارير هذا التطبيق.",
      DUPLICATE_REQUIRED_COLUMN: "عمود مطلوب مكرر في الملف؛ يُستخدم الأول.",
      NO_DATA_ROWS: "الملف يحتوي على صف العناوين فقط دون بيانات.",
      CROSS_FILE_CONFLICT: "طلبات مشتركة مع ملف آخر مسندة إلى فروع مختلفة.",
      WRONG_PROVIDER: "الملف يعود لتطبيق آخر.",
      MISSING_REQUIRED_COLUMNS: "خطأ — أعمدة الملف لا تطابق التقرير المطلوب.",
      WRONG_REPORT_KIND: "نوع الملف لا يطابق التقرير المختار.",
      SECTION_NOT_IN_MODE: "هذا الملف لا يُستخدم في هذا النوع من التحليل.",
      UNKNOWN_REPORT_SECTION: "ملف تقرير غير معروف.",
      STORE_IDENTITY_UNVERIFIED: "لا يوجد صف في الملف يثبت المتجر برقم فرع مسجّل.",
      BRANCH_NOT_MATCHED: "تحذير — الفرع لا يطابق المتجر المختار",
      NO_BRANCH_IN_FILE: "الملف لا يذكر أي فرع.",
      YEAR_UNVERIFIED: "بعض التواريخ لا تحتوي على سنة.",
      PERIOD_UNVERIFIED: "الملف لا يحتوي على تواريخ تبيّن شهر التقرير.",
      SOURCE_PERIOD_DIFFERS_FROM_SELECTED: "تحذير — فترة المصدر تختلف عن الفترة المختارة",
      SOURCE_PERIOD_INCONSISTENT: "هذا الملف يعود لشهر مختلف عن شهر التقرير الشهري لنفس التطبيق.",
      EMPTY_REPORT: "الملف لا يحتوي على صفوف.",
      NO_RELATED_FILE: "لا يوجد ملف آخر يشارك طلبات هذا الملف.",
      PARTLY_RELATED: "بعض الطلبات فقط موجودة في الملفات المرتبطة.",
      PROVIDER_UNCERTAIN: "الأعمدة تطابق تطبيقاً آخر أيضاً.",
      SHEET_NOT_FOUND: "ورقة عمل مطلوبة غير موجودة.",
      INVALID_WORKBOOK: "الملف تالف أو ليس جدول بيانات صالحاً.",
      UNSUPPORTED_FILE_TYPE: "نوع الملف غير مدعوم.",
      FILE_TOO_LARGE: "حجم الملف أكبر من المسموح.",
      EMPTY_FILE: "الملف فارغ.",
      MISSING_PART: "لم يُضمَّن جزء محفوظ من هذا التقرير.",
      LEGACY_PART: "يوجد ملف لهذا الشهر مرفوع قبل تفعيل الإصدارات؛ يجب ترحيله أو حذفه قبل التحليل.",
      SEVERAL_PARTS: (count) => `توجد ${count} أجزاء محفوظة من نفس التقرير. إن كانت نسخاً أسبوعية تراكمية فستُحتسب جميعها.`,
      NO_FILES: "لم تُضف ملفات لهذا التطبيق.",
      HEADER_NOT_FOUND: "لم يُعثر على صف عناوين التقرير؛ الملف ليس بالشكل المتوقع.",
      INVALID_CSV: "تعذّرت قراءة ملف CSV.",
      INVALID_FILE_STRUCTURE: "بنية الملف لا تطابق تقريراً من هذا النوع.",
      ROW_LIMIT_EXCEEDED: "عدد صفوف الملف أكبر من المسموح.",
      UNSUPPORTED_ENCODING: "ترميز نص الملف غير مدعوم.",
      PARSER_FAILED: "تعذّرت قراءة الملف.",
      PARSER_UNAVAILABLE: "تعذّرت قراءة الملفات حالياً؛ لم يُرسل شيء للتحليل.",
      TOO_MANY_FILES: (max) => `أكثر من ${max} ملفاً في التحليل الواحد.`,
      PROTECTED_ROW_CONFLICT: "سجل محمي (نزاع أو اعتراض) سيتغير.",
      AMBIGUOUS_STORED_ROWS: "السجلات المحفوظة غير واضحة ولا يمكن مطابقتها بأمان.",
      CONFLICTING_ROWS_IN_RUN: "الملفات تُنتج سجلات متعارضة.",
      ANALYZER_FAILED: "تعذّر تحليل الملف.",
    },
    resultWarningsTitle: "تم حفظ التحليل مع تحذيرات",
    reportingPeriod: "فترة التقرير",
    replayTitle: "هذا التحليل محفوظ مسبقاً",
    replayHint: "أُرسلت نفس الملفات من قبل؛ هذه نتيجة الحفظ السابق ولم يُحفظ شيء جديد.",
    cleanupPending: "حُفظت التقارير بنجاح. سيُحذف الملف المصدري القديم لاحقاً تلقائياً.",
    leaveWarning: "لديك ملفات لم تُحفظ بعد. هل تريد مغادرة الصفحة؟",
    errors: {
      VALIDATION_FAILED: "يوجد ملف غير مطابق للمتجر أو الشهر أو نوع التقرير. راجع نتيجة التحقق.",
      CONFIRMATION_REQUIRED: "بعض الملفات تحتاج إلى تأكيد قبل المتابعة.",
      CONFIRMATION_INVALID: "انتهت صلاحية التأكيد أو تغيرت الملفات. تحقق من الملفات وأكّد مرة أخرى.",
      ACKNOWLEDGEMENT_REQUIRED: "توجد تحذيرات تحتاج إلى تأكيد صريح (فترة التقرير أو فروع متجر آخر). راجعها وأكّدها قبل المتابعة.",
      UNSAFE_BRANCH_ATTRIBUTION: "تعذّر إسناد بعض الصفوف بأمان إلى فروع المتجر المختار؛ لم يُحفظ شيء.",
      NOTHING_TO_SAVE: "لا يوجد صف يمكن حفظه للمتجر والفترة المختارين؛ لم يُحفظ شيء.",
      SOURCE_PERIOD_INCONSISTENT: "ملف من شهر مختلف عن التقرير الشهري لنفس التطبيق.",
      SLOT_INCOMPLETE: "يجب تضمين جميع الملفات المحفوظة لهذا الشهر. حُدّثت قائمة الملفات.",
      VERSION_CONFLICT: "تغيّر ملف محفوظ أثناء التحضير. حُدّثت قائمة الملفات؛ راجع الاستبدال ثم أعد المعاينة.",
      FILE_SLOT_CONFLICT: "الملف المراد استبداله غير موجود أو قيد الاستبدال. حُدّثت قائمة الملفات.",
      PROTECTED_ROW_CONFLICT: "سجلات محمية (نزاع أو اعتراض) ستتغير.",
      RECONCILIATION_UNSAFE: "لا يمكن مطابقة السجلات المحفوظة بأمان.",
      PREVIEW_REQUIRED: "تغيّرت البيانات منذ المعاينة. راجع المعاينة الجديدة ثم احفظ.",
      TRANSACTION_UNAVAILABLE: "قاعدة البيانات لا تدعم الحفظ الآمن حالياً. تواصل مع الدعم الفني.",
      ANALYSIS_FAILED: "تعذّر إكمال التحليل.",
      PERIOD_MISMATCH: "تواريخ الملفات لا تطابق الشهر والسنة المختارين.",
      COMMIT_FAILED: "تعذّر حفظ التحليل.",
      COMMIT_OUTCOME_UNKNOWN: "لم تؤكد قاعدة البيانات نتيجة الحفظ.",
      UPLOAD_FAILED: "تعذّر رفع ملف إلى التخزين.",
      DOWNLOAD_FAILED: "تعذّر تحميل ملف محفوظ لإرساله. حاول مرة أخرى أو استبدله بنسخة من جهازك.",
      INVALID_MANIFEST: "بيانات الملفات غير صالحة. أعد اختيار الملفات.",
      TOO_MANY_FILES: "عدد الملفات أكبر من المسموح.",
      FILE_TOO_LARGE: "يوجد ملف أكبر من المسموح.",
      RATE_LIMITED: "طلبات كثيرة خلال وقت قصير. انتظر قليلاً ثم حاول مرة أخرى.",
      NETWORK_ERROR: "تعذّر الاتصال بالخادم.",
      CANCELLED: "أُلغيت العملية.",
      FORBIDDEN: "لا تملك صلاحية تحليل تقارير هذا المتجر.",
      fallback: "حدث خطأ غير متوقع.",
    },
  },
  en: {
    title: "Report analysis",
    subtitle: "Upload the original application files; they are checked, analyzed and saved together with the reports.",
    guideVideo: {
      W: (app) => `How to download ${app}'s daily report`,
      M: (app) => `How to download ${app}'s monthly report`,
    },
    flow: {
      ackCheck: "I reviewed these warnings and confirm the files belong to the selected store.",
      ackPeriodCheck: (period) => `I understand that rows of other months contribute to the ${period} monthly report and keep their original dates.`,
      ackDailyCheck: (period, rows) => `I understand that ${rows} rows outside ${period} are excluded and not saved.`,
      ackBranchesCheck: (rows, store) => `I understand that ${rows} rows of branches configured for another store will not be saved to ${store}, and no other store's records are changed.`,
      ackCheckMismatch: "I reviewed the branch details and these warnings and want to continue to the preview.",
      stepper: "Report analysis steps",
      stepLabels: { setup: "Store & Period", files: "Applications & Files", validate: "Checks", preview: "Preview", result: "Save & Result" },
      next: "Next",
      nextCheck: "Next: Check Files",
      backToSetup: "Back to Store & Period",
      backToFiles: "Back to Files",
      backToChecks: "Back to Checks",
      backToPreview: "Back to Preview",
      continuePreview: "Continue to Preview",
      acknowledgeContinue: "Acknowledge & Continue to Preview",
      confirmSave: "Confirm & Save",
      startNew: "Start New Analysis",
      retrySave: "Try saving again",
      retryCheck: "Check again",
      retryPreview: "Prepare the preview again",
      setupTitle: "Store & Period",
      setupHint: "Choose the store, the reporting month and the analysis type. Applications and files come next.",
      filesTitle: "Applications & Files",
      filesHint: "Choose the applications and add their files in the right report section. The files are checked in the next step.",
      chooseApps: "Choose at least one application to continue.",
      filesCount: (n, shown = n) => `${shown} file${n === 1 ? "" : "s"}`,
      noFilesYet: "No files yet",
      checksTitle: "File checks",
      checksHint: "Checks and the preview never save anything.",
      precheckNotice: "Nothing was sent to the server. Correct the problems below in the Files step, then check again.",
      summary: { appsChecked: "Applications checked", filesChecked: "Files checked", rowsChecked: "Source rows checked", appsReady: "Applications ready", appsWarnings: "With warnings", appsErrors: "With blocking errors" },
      overall: { ready: "Ready", readyWithWarnings: "Ready with warnings", requiresCorrection: "Requires correction" },
      blockingTitle: "Correct the errors before continuing",
      blockingHint: (n, shown = n) => `${shown} blocking error${n === 1 ? "" : "s"}. Correct the following, then check again:`,
      noIssues: "No warnings or errors for this application.",
      filesChecked: "Files checked",
      ackTitle: "Acknowledge warnings",
      ackHint: "The warnings must be acknowledged explicitly before the preview. Nothing is saved now.",
      allClear: "No warnings: every file matches the store, period and report type.",
      checking: "Checking the files on the server…",
      previewing: "Preparing the analysis preview…",
      previewTitle: "Analysis preview",
      previewHint: "This is what will be saved when you confirm. All values are calculated by the server from the original files.",
      overview: "Overall summary",
      appsAnalyzed: "Applications analyzed",
      filesAnalyzed: "Files analyzed",
      appSummaries: "Applications",
      staleRetained: "Stale records retained",
      staleExplain: "Stored records that are no longer in the new analysis are retained, not automatically deleted.",
      dbLine: (insert, update, unchanged) => `${insert} new · ${update} updated · ${unchanged} unchanged`,
      databaseChanges: "Database changes",
      warningsSummary: (n) => `Acknowledged warnings (${n})`,
      savingTitle: "Saving",
      savingRunning: "The save request is running. Keep this page open until the result appears.",
      savingApps: "Applications being processed",
      uploadProgress: "Uploading files",
      serverWorking: "Upload finished; the server is analyzing and saving in one transaction…",
      successTitle: "Analysis saved",
      successHint: "The temporary files, checks and preview were cleared from the page. This summary stays visible.",
      appsSaved: "Applications saved",
      filesSaved: "Files saved",
      inserted: "Records inserted",
      updated: "Records updated",
      unchanged: "Records unchanged",
      warningsAcknowledged: "Warnings acknowledged",
      failureTitle: "The save did not complete",
      failureStage: "Stage",
      reason: "Reason",
      application: "Application",
      section: "Section",
      affectedFiles: "Affected files",
      suggestedAction: "Suggested action",
      savedFalse: "The server confirmed that nothing was saved.",
      savedUnknown: "The server could not confirm whether anything was saved. Check the reports before retrying; sending the same files again never saves them twice.",
      filesKept: "Your uploaded files are still on the page for correction and retry.",
      requestFailed: "The request could not be completed",
      checksNeverSave: "Checks and the preview never save anything.",
    },
    details: {
      worksheet: "Worksheet",
      section: "Section",
      missingColumns: "Missing required columns",
      expectedColumns: "Expected columns",
      actualColumns: "Columns in the file",
      moreColumns: (n) => `and ${n} more`,
      suggestion: (expected, actual) => `Expected column "${expected}" — the file has "${actual}". Export the original report, or rename the column to "${expected}".`,
      selectedStore: "Selected store",
      mismatchedBranches: "Branches not matching",
      matchedBranches: "Matched branches",
      noMatchedBranches: "No branch of the selected store is in this file.",
      application: "Application",
      totalAffectedRows: "Total affected rows",
      showBranches: (n, shown = n) => `Show ${shown} branch${n === 1 ? "" : "es"}`,
      crossStoreNote: (rows, store) => `These branches may belong to another store. Please review the branch details before continuing. Their ${rows} rows are not saved to ${store} or assigned to any other branch, and the other store's records are not changed.`,
      branchId: "Branch ID",
      matchedAs: (name) => `matches ${name}`,
      rows: (n, shown = n) => `${shown} row${n === 1 ? "" : "s"}`,
      affectedRows: "Affected rows",
      affectedFile: "Affected file",
      selectedPeriod: "Selected period",
      detectedPeriods: "Periods in the file",
      statementPeriods: "Monthly statement months",
      included: "included",
      excluded: "excluded",
      totalSourceRows: "Total source rows",
      includedRows: "Included rows",
      excludedRows: "Excluded rows",
      assignedRows: (period) => `Rows assigned to ${period}`,
      dailyNote: (included, excluded, period) => `Only the ${included} rows belonging to ${period} will be analyzed and saved. The remaining ${excluded} rows will be excluded.`,
      monthlyNote: (rows, period) => `All ${rows} applicable rows will contribute to the Monthly report for ${period}. Original source dates remain unchanged.`,
      branchExcluded: "excluded",
      branchAssigned: (names) => `assigned to ${names}`,
      branchSharedName: "name also used by another store",
      candidates: (names) => `possible branches: ${names}`,
      unmatchedRows: (rows, more, branch, reason, total) => {
        const where = `${total === 1 ? "Row" : "Rows"} ${rows.replace(/،/g, ",")}${more > 0 ? ` and ${more} more` : ""}`;
        if (reason === "no_branch") return `${where}: no branch name or ID.`;
        if (reason === "ambiguous") return `${where}: Branch '${branch}' matches more than one branch registered under the selected store; none was selected automatically.`;
        if (reason === "no_provider_id") return `${where}: Branch '${branch}' is registered under the selected store but has no branch ID for this application, so its rows cannot be saved.`;
        return `${where}: Branch '${branch}' does not match any branch registered under the selected store.`;
      },
      relatedFile: "Related file",
      duplicateNote: "The same rows in two parts of a report would be counted twice; remove the duplicate part.",
      samples: "Examples",
      action: "Action",
      unknownStore: "—",
    },
    store: "Store",
    storePlaceholder: "Choose the store",
    period: "Report month",
    mode: "Analysis type",
    modes: { W: "Daily", M: "Monthly" },
    apps: "Applications",
    appsHint: "Choose one or more applications.",
    loadingParts: "Loading the saved files…",
    existing: "Saved files",
    keep: "Sent unchanged",
    willReplace: (version) => `Replaced — version ${version}`,
    version: (n) => `Version ${n}`,
    replace: "Replace",
    download: "Download",
    addFiles: "Add files",
    addFile: "Add a file",
    newPart: "New part",
    remove: "Remove",
    noFiles: "No file uploaded",
    optional: "Optional",
    ready: "Ready",
    notReady: "Not ready",
    includeAll: "The analysis reads all of this application's files for the month together, so the saved files are sent too. Files you do not replace are sent unchanged and get no new version.",
    preview: "Preview analysis",
    cancel: "Cancel",
    phases: { preparing: "Preparing files", uploading: "Uploading", validating: "Checking", previewing: "Preparing preview", committing: "Saving reports" },
    processing: "The server is processing the files…",
    protections: { disputed: "Dispute", objected: "Objection", readiness_exception: "Readiness exception" },
    backToFiles: "Back to files",
    notAvailable: "Not available",
    preview2: {
      sourceRows: "Source rows",
      branches: "Branches",
      branch: "Branch",
      byBranch: "By branch",
      savedTo: "Records will be saved to",
      rowsLine: (source, included, excluded) => `Source rows: ${source} · included: ${included} · excluded: ${excluded}`,
      rowsAssignedLine: (source, assigned, excluded, period) => `Source rows: ${source} · assigned to ${period}: ${assigned} · excluded: ${excluded}`,
      rowsIncluded: "Rows included",
      rowsExcluded: "Rows excluded",
      noBranches: "no matching branch; no records are saved for this application",
      excludedRows: (rows, branches) => `Excluded: ${rows} rows of ${branches} branch(es) configured for another store — not saved and not assigned to any branch.`,
      compensationRows: "Compensation records",
      compensationTotal: "Compensation detail total",
      changesTitle: (n, shown = n) => `Difference from saved values (${shown} record${n === 1 ? "" : "s"} will be updated)`,
      field: "Item",
      saved: "Saved now",
      analyzed: "After analysis",
      difference: "Difference",
    },
    metrics: {
      orders: "Completed orders", sales: "Sales", commission: "Commission", paymentFees: "Payment fees", deliveryOffer: "Delivery offers",
      offers: "Offers", vat: "VAT", compensation: "Compensation", rejected: "Rejected orders", canceled: "Cancelled orders", net: "Net",
    },
    review: {
      problem: "Problem",
      details: "Details",
      phases: { preparing: "Preparing files", uploading: "Uploading", validating: "File checks", previewing: "Analysis preview", committing: "Saving" },
      filesCount: (n, shown = n) => `${shown} file${n === 1 ? "" : "s"}`,
      rows: (n, shown = n) => `${shown} row${n === 1 ? "" : "s"}`,
      warningsCount: (n, shown = n) => `${shown} warning${n === 1 ? "" : "s"}`,
      errorsCount: (n, shown = n) => `${shown} error${n === 1 ? "" : "s"}`,
      errorsHeading: "Errors",
      warningsHeading: "Warnings",
      row: "row",
      action: "Action",
      acknowledgedTag: "Acknowledged",
      database: { insert: "inserted", update: "updated", unchanged: "unchanged", stale: "kept for review", conflict: "protected conflicts", added: "files added", replaced: "files replaced" },
      actions: {
        MISSING_REQUIRED_COLUMNS: "Upload the correct export of this report from the application.",
        SHEET_NOT_FOUND: "Upload the complete export that contains all worksheets.",
        WRONG_PROVIDER: "Upload this file under the application it belongs to.",
        WRONG_REPORT_KIND: "Upload the file in the matching report section.",
        SECTION_NOT_IN_MODE: "Choose the analysis type that uses this report, or remove the file.",
        UNKNOWN_REPORT_SECTION: "Remove the file and add it again in the right section.",
        BRANCH_BELONGS_TO_ANOTHER_STORE: "Check the selected store, or upload this store's file.",
        CROSS_STORE_BRANCH_MISMATCH: "Review the branch details before continuing, or select the store the file belongs to.",
        CROSS_FILE_CONFLICT: "Make sure all files come from the same export of the same store.",
        PERIOD_MISMATCH: "Upload the report of the selected month, or select the month the report belongs to.",
        NO_ROWS_IN_PERIOD: "Upload the report of the selected month, or select the month the report belongs to.",
        SOURCE_PERIOD_INCONSISTENT: "Upload the orders and fees files of the same month as the monthly report.",
        ROWS_OUTSIDE_SELECTED_PERIOD: "Check the selected period; rows of other months are not saved.",
        DUPLICATE_ROWS_ACROSS_PARTS: "Remove the duplicate part, then check again.",
        APP_NOT_CONFIGURED: "Add the application account to the store's settings, then check again.",
        INVALID_DATE: "Correct the invalid dates in the file, then upload it again.",
        INVALID_WORKBOOK: "Export the file again from the application and upload it.",
        UNSUPPORTED_FILE_TYPE: "Remove the file on the card and upload an xlsx, xls or csv file.",
        MISSING_PART: "Return to the files: every saved part of this month is sent again.",
        LEGACY_PART: "Open the saved files page and migrate or delete the old file, then check again.",
        NO_FILES: "Add the report files on the card, or deselect the application.",
        HEADER_NOT_FOUND: "Check that the file is this application's report for this section, exported unchanged, then upload it again.",
        INVALID_FILE_STRUCTURE: "Check that the file is this application's report for this section, exported unchanged, then upload it again.",
        INVALID_CSV: "Export the file again from the application and upload it.",
        ROW_LIMIT_EXCEEDED: "Split the export into smaller files.",
        UNSUPPORTED_ENCODING: "Export the file again as xlsx, or as UTF-8 CSV.",
        PARSER_FAILED: "Export the file again from the application and upload it.",
        PARSER_UNAVAILABLE: "Try again in a few minutes.",
        FILE_TOO_LARGE: "Remove the file on the card and upload a smaller export.",
        EMPTY_FILE: "Remove the file on the card and upload the export again.",
        TOO_MANY_FILES: "Remove some files, or analyze the applications separately.",
        PROTECTED_ROW_CONFLICT: "Finish or review the dispute or objection first, then analyze again.",
        COMMIT_OUTCOME_UNKNOWN: "Check this month on the reports page; if the analysis is not there, try again with the same files.",
        BRANCH_NOT_MATCHED: "Review the branches in the file before continuing.",
        AMBIGUOUS_STORED_ROWS: "Contact technical support to review the stored records.",
        ANALYZER_FAILED: (app) => `Upload a valid ${app} report file.`,
        fallback: "Correct the file and check it again.",
      },
    },
    validationStatus: { verified: "Verified", partial: "Partly verified", unverified: "Not verifiable", rejected: "Rejected" },
    issues: {
      PERIOD_MISMATCH: "Rows are dated outside the selected month and year.",
      NO_ROWS_IN_PERIOD: "Error — no row of the file belongs to the selected month and year; there is nothing to analyze or save.",
      ROWS_OUTSIDE_SELECTED_PERIOD: "Warning — Rows outside the selected reporting period",
      DUPLICATE_ROWS_ACROSS_PARTS: "Error — rows of this file also appear in another part of the report.",
      APP_NOT_CONFIGURED: "The store has no account for this application; the file's rows cannot be saved.",
      INVALID_DATE: "Some dates are not valid.",
      BRANCH_BELONGS_TO_ANOTHER_STORE: "Error — the file contains a branch configured for another store.",
      CROSS_STORE_BRANCH_MISMATCH: "Warning — Branches do not match the selected Store",
      LOOKS_LIKE_OTHER_SECTION: "The columns match another report section of this application.",
      DUPLICATE_REQUIRED_COLUMN: "A required column appears twice; the first one is used.",
      NO_DATA_ROWS: "The file has a header row but no data.",
      CROSS_FILE_CONFLICT: "Orders shared with another file are assigned to different branches.",
      WRONG_PROVIDER: "The file belongs to another application.",
      MISSING_REQUIRED_COLUMNS: "Error — the file's columns do not match the required report.",
      WRONG_REPORT_KIND: "The file type does not match the chosen report.",
      SECTION_NOT_IN_MODE: "This file is not used in this analysis type.",
      UNKNOWN_REPORT_SECTION: "Unknown report file.",
      STORE_IDENTITY_UNVERIFIED: "No row of this file proves the store by a configured branch ID.",
      BRANCH_NOT_MATCHED: "Warning — Branch does not match the selected store",
      NO_BRANCH_IN_FILE: "The file names no branch.",
      YEAR_UNVERIFIED: "Some dates name no year.",
      PERIOD_UNVERIFIED: "The file shows no reporting dates.",
      SOURCE_PERIOD_DIFFERS_FROM_SELECTED: "Warning — Report source period differs from selected period",
      SOURCE_PERIOD_INCONSISTENT: "This file belongs to another month than the application's monthly report.",
      EMPTY_REPORT: "The file has no rows.",
      NO_RELATED_FILE: "No other file shares this file's orders.",
      PARTLY_RELATED: "Only some orders appear in the related files.",
      PROVIDER_UNCERTAIN: "The columns also match another application.",
      SHEET_NOT_FOUND: "A required worksheet is missing.",
      INVALID_WORKBOOK: "The file is damaged or not a valid spreadsheet.",
      UNSUPPORTED_FILE_TYPE: "The file type is not supported.",
      FILE_TOO_LARGE: "The file is larger than allowed.",
      EMPTY_FILE: "The file is empty.",
      MISSING_PART: "A saved part of this report was not included.",
      LEGACY_PART: "A file of this month was uploaded before versioning; it must be migrated or deleted before analysis.",
      SEVERAL_PARTS: (count) => `${count} saved parts of the same report exist. If they are cumulative weekly copies, all of them are counted.`,
      NO_FILES: "No files were added for this application.",
      HEADER_NOT_FOUND: "The report's header row was not found; the file does not have the expected layout.",
      INVALID_CSV: "The CSV file could not be read.",
      INVALID_FILE_STRUCTURE: "The file structure is not a report of this type.",
      ROW_LIMIT_EXCEEDED: "The file has more rows than allowed.",
      UNSUPPORTED_ENCODING: "The text encoding of the file is not supported.",
      PARSER_FAILED: "The file could not be read.",
      PARSER_UNAVAILABLE: "Files cannot be read right now; nothing was sent for analysis.",
      TOO_MANY_FILES: (max) => `More than ${max} files in one analysis.`,
      PROTECTED_ROW_CONFLICT: "A protected record (dispute or objection) would change.",
      AMBIGUOUS_STORED_ROWS: "Stored records are ambiguous and cannot be matched safely.",
      CONFLICTING_ROWS_IN_RUN: "The files produce conflicting records.",
      ANALYZER_FAILED: "The file could not be analyzed.",
    },
    resultWarningsTitle: "Analysis saved with warnings",
    reportingPeriod: "Reporting period",
    replayTitle: "This analysis was already saved",
    replayHint: "The same files were submitted before; this is the earlier result and nothing new was saved.",
    cleanupPending: "The reports were saved. The old source file will be removed automatically later.",
    leaveWarning: "You have files that are not saved yet. Leave the page?",
    errors: {
      VALIDATION_FAILED: "A file does not match the store, month or report type. See the checks.",
      CONFIRMATION_REQUIRED: "Some files need confirmation before continuing.",
      CONFIRMATION_INVALID: "The confirmation expired or the files changed. Check the files and confirm again.",
      ACKNOWLEDGEMENT_REQUIRED: "Some warnings need an explicit acknowledgement (report period or branches of another store). Review and acknowledge them first.",
      UNSAFE_BRANCH_ATTRIBUTION: "Some rows could not be assigned safely to a branch of the selected store; nothing was saved.",
      NOTHING_TO_SAVE: "No row can be saved for the selected store and period; nothing was saved.",
      SOURCE_PERIOD_INCONSISTENT: "A file belongs to another month than the application's monthly report.",
      SLOT_INCOMPLETE: "All saved files of this month must be included. The file list was refreshed.",
      VERSION_CONFLICT: "A saved file changed meanwhile. The file list was refreshed; review the replacement and preview again.",
      FILE_SLOT_CONFLICT: "The file to replace no longer exists or is being replaced. The file list was refreshed.",
      PROTECTED_ROW_CONFLICT: "Protected records (dispute or objection) would change.",
      RECONCILIATION_UNSAFE: "The stored records cannot be matched safely.",
      PREVIEW_REQUIRED: "The data changed since the preview. Review the new preview, then save.",
      TRANSACTION_UNAVAILABLE: "The database cannot save safely right now. Contact technical support.",
      ANALYSIS_FAILED: "The analysis could not be completed.",
      PERIOD_MISMATCH: "The file dates do not match the selected month and year.",
      COMMIT_FAILED: "The analysis could not be saved.",
      COMMIT_OUTCOME_UNKNOWN: "The database did not confirm the outcome of the save.",
      UPLOAD_FAILED: "A file could not be uploaded to storage.",
      DOWNLOAD_FAILED: "A saved file could not be loaded to send it. Try again, or replace it with a copy from your computer.",
      INVALID_MANIFEST: "The file details are invalid. Choose the files again.",
      TOO_MANY_FILES: "Too many files.",
      FILE_TOO_LARGE: "A file is larger than allowed.",
      RATE_LIMITED: "Too many requests in a short time. Wait a moment and try again.",
      NETWORK_ERROR: "The server could not be reached.",
      CANCELLED: "Cancelled.",
      FORBIDDEN: "You may not analyze this store's reports.",
      fallback: "Something unexpected went wrong.",
    },
  },
};

export const errorText = (text, error) => {
  if (!error) return null;
  if (error.status === 403) return text.errors.FORBIDDEN;
  return text.errors[error.code] || text.errors.fallback;
};
